export default class Paylines extends React.Component {
  getReelDimensions(paylines) {
    const width = paylines[0] ? paylines[0].length : 0

    if (width <= 0) {
      console.warn("Warning: Paylines[0] undefined")
    }

    let tempHeight = 0
    for (let i = 0; i < paylines.length; i++) {
      for (let j = 0; j < paylines[i].length; j++) {
        if (paylines[i][j] > tempHeight) {
          tempHeight = paylines[i][j]
        }
      }
    }
    return { width, height: tempHeight + 1 }
  }

  renderPayline(symbol, width, height, index, color = '#fcb101', unlitColor = '#545250') {
    let cols = []
    for (let i = 0; i < height; i++) {
      let rows = []
      for (let j = 0; j < width; j++) {
        rows.push(symbol[j] === i)
      }
      cols.push(rows)
    }
    return (
      <div key={index} className="flex-container" style={{ width: `${16 * width}px`}}>
        <p className="number">{index + 1}</p>
        
        { cols.map((col) => (
          col.map((isColored) => (
            <div className={'square'} style={{ backgroundColor: isColored ? color : unlitColor }}/>
          ))
        ))}
      </div>
    )
  }

  render() {
    const { paylines, color, unlitColor } = this.props
    const { width, height } = this.getReelDimensions(paylines)

    
    return (
      <div className="paylines flex-container">
        {paylines.map((symbol, index) => (
            this.renderPayline(symbol, width, height, index, color, unlitColor)
          ))}
      </div>
    )
  }
}
